export default {"src":"/_next/static/media/Services.72a6496b.svg","height":66,"width":65,"blurWidth":0,"blurHeight":0};